import { useState } from 'react';
import RestProvider from 'providers/RestProvider';
import { properties as appProperties } from '../../../AppData';
//import { cabecerasTabla } from './CreacionFormulariosData';
import { useHistory } from "react-router-dom";
import { saveState } from './../../../providers/localStorage';
import { localStorageName } from 'providers/localStorageData';

const useOperations = () => {
    const history = useHistory();
    const pathOrigen = '/MenuNavegacion';
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const [listadoFormularios, setListadoFormularios] = useState([]);

    const { crudOperation, crudOperationsType } = RestProvider();

    //Inicialización necesaria para el componente Alert de mensajes y errores
    const [message, setMessage] = useState({ msg: "", severity: "" });
    const [alerts, setAlerts] = useState([]);
    let _ID = 0;
    const addAlert = msg => setAlerts([...alerts, { id: _ID++, msg }]);

    const handleSetMessage = (msg, severity) => {
        setMessage({ msg, severity });
        addAlert(message);
    }

    const [mostrarPopUp, setMostrarPopUp] = useState(false); //Muestra o no el popup
    /**Método que capta el tamaño de la ventana y actualiza actualiza
        ***el hook que controla cuando se da el salto a versión movil*/
    const updateFormat = () => {
        if (window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    };

    /**
         * @constant headerTableObject Obtención del objeto que recibe la tabla con los valores a insertar en la cabecera
         * @param {*} funcionOrdena Función que recibe
         * @returns {headersObject} Devuelve un array de objetos con las cabeceras de la tabla
         */
    //const headerTableObject = (funcionOrdena) => {
      //  let headersObject = []; //Array declarado, donde se insertarán los objetos
        //Paso 1. Se recorre el array recibido con las cabeceras
        //for (const valores of cabecerasTabla) {
            //Paso 2. Estructura condicional, que determina si el valor de la cabecera es acción o no, ya que es el único valor que tiene propiedades diferentes en su objeto.
            //if (valores != 'ACCIONES') {
                //Paso 3. Se inserta dentro de el array el objeto que recibirá el componente tablaGenercia
               /* headersObject.push(
                    {
                        titulo: valores,
                        esBotonera: false,
                        funcionOrdenacion: funcionOrdena
                    }
                );
            } else {
                headersObject.push(
                    {
                        titulo: valores,
                        esBotonera: true,
                        funcionOrdenacion: null
                    }
                );
            }               
        }
        return headersObject;
    }*/

    /**
     * @constant dataTabletObject Obtención del objeto que recibe la tabla con los valores a insertar en ella
     * @returns Se devuelve el objeto que alimentará la tabla
     */
    const dataTableObject = () => {
        let dataObject = []; //Array que contendrá los objetos

        //Recorrido del objeto para obtener los valores a insertar en la tabla
        listadoFormularios.map(valores => {            
            dataObject.push({
                nombre: valores.title,
                tipo: valores.type,
                acciones: [{funcion:"", img:"Editar Formulario", redirect: "/"}, 
                            {funcion:"", img:"Eliminar Formulario", redirect: "/"}, 
                            {funcion:"", img:"Rellenar Formulario", redirect: "/"},
                            {funcion:"", img:"Ver Datos Enviados", redirect: "/"}]
            })
        })
        return dataObject;
    }

    /*const handleAction = (form, action) => {

        switch (action) {
          case 'edit':
            doRedirect(redirect, 'builder', 'edit', form.path);
            break;
          case 'delete':
            setSelectedForm(form);
            setDeletePopupOpen(true);
            break;
          case 'submission':
            doRedirect(redirect, 'formulario', 'edit', form.path);
            break;
          case 'dataSubmitted':
            doRedirect(redirect, 'submission/list', 'edit', form.path);
            break;
          default:
            return null;
        }
      }*/
    

    /**
     * @constant fotmatearFecha Se formatea la fecha obtenida y se formatea según el formato DD/MM/YYYY.
     * @param {*} fechaObtenida Se recibe la fecha obtenida
     * @returns Devuelve la fecha en formato DD/MM/YYYY
     */
    const formatearFecha = (fechaObtenida) => {
        //Paso 1. Se extrae de la fecha obtenida solo el año, el mes y el dia. La fecha se obtiene en este formato 2020-06-26T10:00:52.000+0000
        fechaObtenida = fechaObtenida.substring(0, 10);
        //Paso 2. Se convierte la cadena de String con la fecha obtenida en fecha
        let fecha = new Date(fechaObtenida);
        //Paso 3. Se convierte y devuelve la fecha con el formato DD/MM/YYYY
        return fecha.getDate() + '/' + (fecha.getMonth() + 1) + '/' + fecha.getFullYear();
    }

    const redirectModuloAdmin = () => {
        setMostrarPopUp(true);
    }

    /**
     * @function cancelarContinuacion Función que cancela la continuación del formulario cunado no se han guardado los valores de este
     */
     const cancelarContinuacion = accion => {
        setMostrarPopUp(accion);
    }
    /**
     * @function aceptarContinuacion Función que acepta la continuación del formulario cunado no se han guardado los valores de este
     */
     const aceptarContinuacion = () => {
        //Paso 1. Se inserta la ruta a la que se redirigirá
        saveState(localStorageName.redirect, pathOrigen, false);
        history.push(pathOrigen);
        //Paso 2. Se establece a (false) la hook que almacena el estado del componente para que se oculte el popup
        setMostrarPopUp(false);
    }

    /**
     * @function buildButtonJS Función que construye un botón y lo inserta como hijo en un elemento del DOM
     * @param {*} querySelector Recibe el elemento padre del DOM del cual colgará el botón
     * @param {*} atributos Objeto que contendrá los atributos
     * @param {*} textoBtn Texto del botón
     * @param {*} eventOnClick Función que se ejecutará con el evento onClick
     */
    const buildButtonJS = (querySelector, atributos, textoBtn, eventOnClick) => {
        let boton = document.createElement('button');
        let keysAtributos = Object.keys(atributos);
        let valuesAtributos = Object.values(atributos);
        for (const key of keysAtributos) {
            for (const valor of valuesAtributos) {
                atributos[key] === valor &&
                    boton.setAttribute(key, valor);
            }
        }
        boton.innerText = textoBtn;
        boton.onclick = eventOnClick;
        document.querySelector(querySelector).appendChild(boton);
    }

    return {
        listadoFormularios, setListadoFormularios, isPhoneVersion,
        crudOperation, crudOperationsType, handleSetMessage, updateFormat, redirectModuloAdmin, cancelarContinuacion, mostrarPopUp, aceptarContinuacion, buildButtonJS,
        alerts, setMessage, message
    };
}
export default useOperations;